import React from 'react';
import './slider-polysorbceiling.css';
import Polysorbceiling1 from '../../images/polysorb/ceiling1.webp';
import Polysorbceiling2 from '../../images/polysorb/ceiling1.webp';
function slider() {
	return (
	  
	<>
	<div id="slider-polysorbceiling">
		<div id="carouselExampleIndicators3" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators3" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators3" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Polysorbceiling1} alt="Polysorb Ceiling1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>ACOUSTICAL CEILING PANELS</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Polysorbceiling2} alt="Polysorb Ceiling2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>ACOUSTICAL CEILING PANELS</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators3" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators3" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;